// extracted by mini-css-extract-plugin
export default {"bg-primary-dark":"FormDescription_bg-primary-dark__+SgNW","bg-primary-light":"FormDescription_bg-primary-light__MLUwk","root":"FormDescription_root__PGIzN"};